/** Roles autorizados a consultar el historial de sync de inventario (API + UI). */
export const CART_INVENTORY_SYNC_ROLES = ['Administrador', 'Soporte']

/**
 * @param {string|null|undefined} role
 * @returns {boolean}
 */
export const canAccessCartInventorySync = role =>
  Boolean(role) && CART_INVENTORY_SYNC_ROLES.includes(role)
